import Vue3MobileDetection from "vue3-mobile-detection";
import { createApp } from 'vue'
import App from './App.vue'

const app = createApp(App);
app.use(Vue3MobileDetection);
app.mount('#app');
